export default function Heading({
  level,
  children,
  ...attrs
}: { level: number | string; children: React.ReactNode } & any) {
  const Tag = `h${level}`;
  return <Tag {...attrs}>{children}</Tag>;
}
